import React from "react";
import SparkleIcon from "Components/common/SparkleIcon";
import UpgradeIconTooltip from "Components/Paywall/UpgradeIconTooltip";
import userDetail from "Stores/userDetail";
import PaywallUtils from "Utils/PaywallUtils";

// SG-2182: new users see this empty state with Copilot as the primary,
// recommended action. Manual creation stays available as a secondary link
// (matches prod) — it reuses the same "Create New" flow existing users get,
// opening the plain name-entry popup that leads to the manual editor.
const NoSequenceComponent = (props = {}) => {
  const {
    showSequenceProp,
    newSequenceBtnAction,
    createManuallyAction,
    showUpgrade = "dalse"
  } = props;

  const {
    noOfSequencesEligible = 0,
    noOfSequencesUsed = 0,
    inFreePlan = false,
    planName = ""
  } = userDetail.userFeatureFlag || {};

  return (
    <div className="emptySequence">
      <div className="emptySequence__iconBadge">
        <SparkleIcon />
      </div>
      <h6>Let's build your first sequence</h6>
      <p className="emptySequence__subtext">
        Answer a few questions. Copilot drafts the steps, copy and timing,
        ready to review in under a minute.
      </p>
      {!showSequenceProp && (
        <div className="createBtn">
          <button
            id="newSequence"
            name="newSequence"
            type="button"
            onClick={newSequenceBtnAction}
          >
            <SparkleIcon />
            <span className="btn-name">Create Sequence</span>
          </button>
          {showUpgrade && (
            <span className="freemiumIconTooltip">
              <UpgradeIconTooltip
                plan={PaywallUtils.getPlanName(planName, inFreePlan)}
                type="newSequence"
                enableTooltip={true}
                alignTooltip="btmRight"
                showIcon={true}
              />
            </span>
          )}
        </div>
      )}
      {!showSequenceProp && createManuallyAction && (
        <button
          id="createSequenceManually"
          name="createSequenceManually"
          type="button"
          className="emptySequence__manualLink"
          onClick={createManuallyAction}
        >
          Prefer to do it yourself? <span>Create manually</span>
        </button>
      )}
    </div>
  );
};

export default NoSequenceComponent;
export { NoSequenceComponent };
